import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Goes back to the previous in-app page when one exists; falls back to a hardcoded path.
// React Router v6 stores the history position in window.history.state.idx (0 = fresh load).
export function useBack(fallback) {
  const navigate = useNavigate();
  return () => {
    if (window.history.state?.idx > 0) navigate(-1);
    else navigate(fallback);
  };
}

export function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handler = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return width;
}

// Fire a haptic pulse if the user has enabled haptics and the device supports it.
// Silently no-ops on iOS, desktop, or when disabled in Settings.
export function buzz(ms = 25) {
  try {
    if (localStorage.getItem('haptics_enabled') !== 'true') return;
    if (navigator.vibrate) navigator.vibrate(ms);
  } catch {}
}
